export default __webpack_public_path__ + "static/media/holiday1.ef588b2f.jpeg";